/*
 * @Description: 绩效审批
 * @Author: 杨志航
 * @Date: 2026-01-21 17:05:28
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import CacheRoute, { CacheSwitch } from 'react-router-cache-route'
import Main from './Main'
import Detail from './Detail'

const AchAudit = ({ match, history }) => {

  return (
    <CacheSwitch>
      <Route path={match.path + '/detail'} component={Detail} />
      <CacheRoute component={Main} />
    </CacheSwitch>
  )
}

export default AchAudit
